import React, { useEffect } from 'react';
// jquery $ is loaded globally and available to this component without import requirement

// See the jsonform documentation for required fields that must be passed in the data object

const JsonForm = ({data}) => {
    useEffect(() => {
        if (!data) return

        // make sure any previous jquery event handlers and jsonform fields have been removed before loading again with the current data
        $('#jsonformControlled').off()
        $('#jsonformControlled').empty()

        // jsonform.js sets originalConfig from this global window object. Set this before calling jsonForm jquery function so that it is available to its context
        window.componentConfig = data.loadedComponentConfig
        $('#jsonformControlled').submit(event => {
            event.preventDefault()
            console.log('event submit called', event)
            return false
        })

        // attach form change handler so that caller knows the form is dirty and can present option of saving data on navigation change
        if (data.onFormChange) {
            $('#jsonformControlled').on('input', data.onFormChange)
        }

        // render form 
        $('#jsonformControlled').jsonForm(data)
        
        // attach cancel handler if the caller provided it
        if (data.onCancel) {
            const btnCancel = document.getElementById('btnCancel');

            if (btnCancel) {
                btnCancel.addEventListener('click', data.onCancel);
            }
        }

        return () => {
            $('#jsonformControlled').off()
            $('#jsonformControlled').empty()
            window.componentConfig = null
        }

    }, [data]); // Re-apply if props change

    return (
        <>
        <div id="jsonformContainer" className="px-3">
            <form id="jsonformControlled" onSubmit={(event) => {event.preventDefault(); return false}}></form>
        </div>
        <p className="fw-light ps-3 my-3">* Highlighted fields are required</p>
        </>
    );
};

export default JsonForm;
